import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import EsccValidateModalUI from './EsccValidateModalUI.js'

class EsccValidateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = { successMsg: null, errorList: null, submitted: false }
  }

  render() {
    return (
      <EsccValidateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        accountName={this.props.accountName}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    if (this.state.submitted) return
    this.setState({ successMsg: null, errorList: [], submitted: true })

    RestApiUtils.post(this.props.context,
      `/api/su/esccValidation/${this.props.bankAccountNumber}/validate`,
      this.onSubmitCallback, {}
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => errorList.push(error.message))
    this.setState({ successMsg: response.success, errorList: errorList, submitted: false })
    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  onCancelClick = () => {
    this.setState({ errorList: null, submitted: false })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => { this.setState({ errorList: errorList }) }
}

export default EsccValidateModalSF